import { render, staticRenderFns } from "./project-conversation-gate.vue?vue&type=template&id=4e97818f&scoped=true"
import script from "./project-conversation-gate.vue?vue&type=script&lang=js"
export * from "./project-conversation-gate.vue?vue&type=script&lang=js"
import style0 from "./project-conversation-gate.vue?vue&type=style&index=0&id=4e97818f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../mnt/host/d/wwwroot/deepcityAI/user-client-pc/user-client-common-pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e97818f",
  null
  
)

export default component.exports